<template>
  <transition name="fade">
    <div v-if="modelValue"
         class="overlay">
      <div class="dialog">
        <div class="header">
          <h3>公告列表</h3>
          <button class="close-btn"
                  @click="closeDialog">×</button>
        </div>
        <div class="content">
          <ul>
            <li v-for="(announcement, index) in announcements"
                :key="index">
              <strong class="content-text">{{ announcement.title }}</strong>
              <p>{{ announcement.content }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { defineProps } from 'vue'

defineProps<{
  modelValue: boolean // 控制弹窗显示/隐藏
  announcements: { title: string; content: string; date: string }[] // 公告数据
}>()

const emit = defineEmits(['update:modelValue'])

const closeDialog = () => {
  emit('update:modelValue', false) // 关闭弹窗
}
</script>

<style scoped>
/* 遮罩层 */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

/* 弹窗样式 */
.dialog {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}

/* 标题栏 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
}

/* 关闭按钮 */
.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

/* 公告内容 */
.content {
  margin-top: 50px;
  max-height: 300px;
  overflow-y: auto;
}
.content-text {
  font-weight: 1000;
  color: red;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  padding: 10px;
  border-bottom: 1px solid #eee;
}

li:last-child {
  border-bottom: none;
}

li p {
  margin: 0;
  line-height: 1.6;
  white-space: pre-line;
  color: #000000;
}

.date {
  font-size: 12px;
  color: gray;
}

/* 过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
